import React from 'react';
import { UPDATE_TYPE_PROPERTIES } from '../../utils/constants';


const NotificationBadge = ({ count, type, className, icon: Icon }) => {
  if (!count || count === 0) return null;
  
  return (
    <span className={`px-2.5 py-1 text-xs font-medium border backdrop-blur-sm rounded-full transition-all duration-200 flex items-center gap-1 ${className}`}>
      <Icon size={14} />
      {count}
    </span>
  );
};

export const AlarmNotification = ({ count }) => (
  <NotificationBadge
    count={count}
    type="alarm"
    icon={UPDATE_TYPE_PROPERTIES.alarms.icon}
    className={`border-red-500/50 text-red-500 hover:bg-red-500/10`}
  />
);

export const FaultNotification = ({ count }) => (
  <NotificationBadge
    count={count}
    type="fault"
    icon={UPDATE_TYPE_PROPERTIES.faults.icon}
    className={`border-orange-500/50 text-orange-500 hover:bg-orange-500/10`}
  />
);


export const ReadingsNotification = ({ value, quality, data_type}) => {
  if (!value && value !== 0) return null;
  const is_good = quality >= 192;
  
  let displayValue;
  let textColor;

  switch(data_type) {
    case 'Digital':
      if (value === "True" || value === true || value === 1 || value === "1") {
        displayValue = "ON";
        textColor = "text-green-500";
      } else {
        displayValue = "OFF"; 
        textColor = "text-red-500";
      }
      break;
    case 'Float':
      displayValue = parseFloat(value).toFixed(2);
      textColor = "text-blue-500";
      break;
    case 'Numeric':
      displayValue = value;
      textColor = "text-blue-500";
      break;
    case 'Unknown':
    default:
      displayValue = value;
      textColor = "text-blue-500";
      break;
  }

  return (
    <span className={`text-sm font-medium border ${is_good ? 'border-blue-500/30' : 'border-red-500/30'} px-2 py-1 rounded-lg ${textColor} backdrop-blur-sm hover:bg-blue-500/10 transition-colors duration-200 flex items-center gap-1`}>
      <UPDATE_TYPE_PROPERTIES.readings.icon size={14} />
      {displayValue}<span className={`text-xs ${is_good ? 'text-gray-500' : 'text-red-400'}`}>({quality})</span>
    </span>
  );
};

// Usage example:
// <SystemAlarmNotification count={5} />
// <SensorFaultNotification count={2} />
// <GenerativeAlarmNotification count={3} />
// <WorkOrderNotification count={1} />
// <SensorValue value={23.45} unit="°C" />
